module.exports = __webpack_public_path__ + "img/emi_logo.be8c62f1.png";